module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n        " + _vm._s(_vm.data.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                ")]) : (props.column.field == 'total_coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'customer_name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer_name
          }
        }, [(props.row.customer_name) ? _c('span', [_vm._v("\n                        " + _vm._s(props.row.customer_name) + "\n                    ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33b1612f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsibles/learning/components/projectTypesProjects.vue
// module id = 841
// module chunks = 0